import React from 'react'
/* COMPONENTS */
import styled from 'styled-components'
import { FaSearch } from 'react-icons/fa';

const CardWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    label{
        font-family: "Poppins";
        font-weight: 400;
        font-style: normal;
        margin-bottom: 0rem;
    }


    @media screen and (max-width:720px){
        justify-content: center;
        align-items: center;

        div > input{
            width:100%;
        }
        
    }
    

`
const InputEl = styled.input`
    font-family: "Poppins";
    font-weight: 500;
    font-size: 1rem;
    color: black;
    padding-left: 0.9rem;
    width: 290px;
    padding-left: 39px;
    height: 45px;
    border:1px solid rgb(215, 215, 215);
    outline:none;
    border-radius: 60px;

    @media screen and (max-width:720px){
        width: 100%;
    }


`
const CardInput = styled.div`
    width: 290px;
    height: 45px;
    position: relative;

    svg{
        position: absolute;
        left: 10px;
        top: 13px;
    }

`


const InputFilter = ({ name,onChange,onBlur,placeholder,width }) => {

    return (
        <CardWrapper >
            <CardInput>
            <InputEl placeholder={!placeholder ? 'Pesquisar' : placeholder } onBlur={onBlur}  onChange={onChange}/>
            <FaSearch size={20} color=''/>
            </CardInput>
        </CardWrapper>
    )
}

export default InputFilter